/* Copyright 2011-2012 The MathWorks, Inc. */

define([
    "dojo/_base/declare"
], function (declare) {
    return declare(null, {
        
        postCreate: function() {
            this.inherited(arguments);
            this._addDataAttribute("tag");
            this._addDataAttribute("type");
        },

        _addDataAttribute: function (attribute, value) {
            value = value || this[attribute];
            if (this.domNode) {
                this.domNode.setAttribute("data-" + attribute, value);
            }
        },

        _setTagAttr: function (value) {
            this._addDataAttribute("tag", value);
            this._set("tag", value);
        },

        _setTypeAttr: function (value) {
            this._addDataAttribute("type", value);
            this._set("type", value);
        }
    });
});

